/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes/'
export default StyleSheet.create({
  container: {
    flex: 1,
    height : 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: Fonts.style.color.disable,
   
    borderWidth : 1,
    backgroundColor : "#FFFFFF"
    
  }, 
  textStyle : { 
    color: 'white',
    fontSize: 15,
    fontFamily:Fonts.style.font.light
  },
  textStyleBold : { 
    color: 'white',
    fontSize: 15,
    fontFamily:Fonts.style.font.bold
  }
})
